import React from 'react';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';
import { ExternalLink } from './ExternalLink';

export const LE3_4 = () => (
  <Section>

    <UL disc>
      <LI>
        Repräsentative Umfrage von Greenpeace zum Modekonsum, Tragedauer und Entsorgung in Deutschland:
        <br />
        <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/20151123_greenpeace_modekonsum_flyer.pdf">https://www.greenpeace.de/&hellip;modekonsum_flyer.pdf</ExternalLink>
      </LI>
      <LI>
        Erklärfilm über den Lebenszyklus eines Baumwoll-Shirts (Englisch mit deutschen Untertiteln):
        <br />
        <ExternalLink href="https://www.kraftfuttermischwerk.de/blogg/der-lebenszyklus-eines-t-shirts/">https://www.kraftfuttermischwerk.de&hellip;lebenszyklus-eines-t-shirts/</ExternalLink>
      </LI>
      <LI>
        Bericht über die Näherin Shila:
        <br />
        <ExternalLink href="https://www.zeit.de/2014/17/bangladesch-naeherin-shila-begum" />
        (Die Zeit; 2014)
      </LI>
      <LI>
        Film: Interview mit einer Textil-Arbeiterin in Bangladesch:
        <br />
        <ExternalLink href="https://www.youtube.com/watch?v=2IMGwuXgZTY&list=PLrJ57fSkPxcc0rgcldUISKysEpmAjtQs2&index=3&t=0s">https://www.youtube.com/watch&hellip;tQs2&index=3&t=0s</ExternalLink>
        (BMZ; 2015)
      </LI>
      <LI>
        Film: Fast Fashion: Schnelle Mode ist im Trend
        <br />
        <ExternalLink href="https://www.youtube.com/watch?v=0H2WcFiAyrU" />
        (ARD-Mittagsmagazin; 2018)
        <br />
        Erklärung Fast Fashion, Produktion und Recycling
      </LI>
      <LI>
        2012 für die berufliche Bildung entwickelt, sehr umfangreich zum Thema Arbeitsbedingungen etc.:
        <br />
        <ExternalLink href="http://www.globaleslernen.de/sites/default/files/files/education-material/epiz_berufe_global_g_mode_und_textil.pdf">http://www.globaleslernen.de&hellip;mode_und_textil.pdf</ExternalLink>
      </LI>
      <LI>
        Hintergrundinformationen zu Produktionsstätten von Textilien sowie Interviews mit Näherinnen und Nähern, Informationen zum bestehenden internationalen Rechtsrahmen:
        <br />
        <ExternalLink href="https://saubere-kleidung.de/wp-content/uploads/2018/10/menschenrechte_textilindustrie_2018.pdf">https://saubere-kleidung.de&hellip;textilindustrie_2018.pdf</ExternalLink>
      </LI>
      <LI>
        Arbeitsbedingungen in der Textilbranche inkl. Verbrauchertipps
        <br />
        <ExternalLink href="http://www.bmz.de/de/themen/textilwirtschaft/hintergrund/index.html">http://www.bmz.de/de/themen/textilwirtschaft/hintergrund/</ExternalLink>
      </LI>
      <LI>
        Thema Giftstoffe in Kleidung:
        <br />
        <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/gpbm_gefaehrliche_chemie_in_textilien_saubere_mode_ist_moeglich.pdf">https://www.greenpeace.de&hellip;saubere_mode_ist_moeglich.pdf</ExternalLink>
      </LI>
      <LI>
        Bericht über das Unternehmen Zara (Süddeutsche Zeitung vom 31. August 2018)
        <br />
        <ExternalLink href="https://www.sueddeutsche.de/wirtschaft/fast-fashion-zara-hat-die-wegwerfmode-perfektioniert-1.4109496">https://www.sueddeutsche.de&hellip;perfektioniert-1.4109496</ExternalLink>
      </LI>
      <LI>
        Artikel über H&M (u. a. auch über Ziele der Nachhaltigkeit vs. Greenwashing):
        <br />
        <ExternalLink href="https://www.sueddeutsche.de/wirtschaft/mode-hm-scheitert-an-sich-selbst-1.3972267">https://www.sueddeutsche.de&hellip;an-sich-selbst-1.3972267</ExternalLink>
        <br />
        (Süddeutsche Zeitung; 9. Mai 2018)
      </LI>
      <LI>
        Bericht über Secondhand-Aufbereitung in Bulgarien, u. a. auch zum Thema Retouren:
        <br />
        <ExternalLink href="https://www.zeit.de/wirtschaft/2018-11/bulgarien-second-hand-geschaeft-fast-fashion">https://www.zeit.de&hellip;second-hand-geschaeft-fast-fashion</ExternalLink>
      </LI>
      <LI>
        Bericht über Fast Fashion im Altkleidercontainer:
        <br />
        <ExternalLink href="https://www.rundschau-online.de/wirtschaft/volle-altkleidercontainer-getragene-kleidung-taugt-selbst-als-putzlappen-nicht-31767118">https://www.rundschau-online.de&hellip;selbst-als-putzlappen-nicht-31767118</ExternalLink>
      </LI>
      <LI>
        Umfrage von Greenpeace zum Thema Online-Bestellungen und Retouren:
        <br />
        <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/umfrage_zum_online-kaufverhalten_2018-se.pdf">https://www.greenpeace.de&hellip;online-kaufverhalten_2018-se.pdf</ExternalLink>
      </LI>
      <LI>
        Bericht über das Import-Verbot von Secondhand-Kleidung in Ruanda:
        <br />
        <ExternalLink href="https://www.zeit.de/2019/02/ruanda-import-altkleidung-textilindustrie-globalisierung">https://www.zeit.de&hellip;textilindustrie-globalisierung</ExternalLink>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3_4.js